import { IMG_URL } from "../../constant";
import { BtnBack, BtnClose, BtnLinkWithIcon, BtnMore } from "../style/styled";

export function CompBtnBack({ onClick }) {
  return (
    <BtnBack onClick={onClick}>
      <span>
        <svg
          width="40"
          height="29"
          viewBox="0 0 40 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_190_171)">
            <path
              d="M14.3186 28.0417L0.562622 14.4452L14.3186 0.848816"
              stroke="black"
              strokeMiterlimit="10"
            />
            <path
              d="M40 14.4452L0.562622 14.4452"
              stroke="black"
              strokeMiterlimit="10"
            />
          </g>
          <defs>
            <clipPath id="clip0_190_171">
              <rect
                width="40"
                height="27.7411"
                fill="white"
                transform="translate(0 0.574646)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
    </BtnBack>
  );
}

export function CompBtnMore({ onClick }) {
  return (
    <BtnMore type="button" onClick={onClick}>
      더 읽어보기
      <span>
        <svg
          width="36"
          height="33"
          viewBox="0 0 36 33"
          fill="none"
          className="icon-more"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_190_175)">
            <path
              d="M35.07 14.82L17.71 32.17L0.349976 14.82"
              stroke="black"
              strokeMiterlimit="10"
            />
            <path d="M17.71 0V32.17" stroke="black" strokeMiterlimit="10" />
          </g>
          <defs>
            <clipPath id="clip0_190_175">
              <rect width="35.42" height="32.88" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </BtnMore>
  );
}

export function CompBtnClose({ onClick }) {
  return (
    <BtnClose>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1L24.44 24.4341" stroke="black" stroke-miterlimit="10" />
        <path d="M1 24.4341L24.44 1" stroke="black" stroke-miterlimit="10" />
      </svg>
    </BtnClose>
  );
}

export function CompBtnLinkWithIcon({ text, link }) {
  return (
    <BtnLinkWithIcon href={link} target="_blank">
      <span className="icon">
        <img src={`${IMG_URL}/icon-link.png`} alt="icon" />
      </span>
      <span>{text}</span>
    </BtnLinkWithIcon>
  );
}
